"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkerInfo;
var _react = require("react");
var _enums = require("../enums");
var _utilities = require("../../utilities");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useMarkerInfo() {
  var _useMemo;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    markerInfo = _useState2[0],
    setMarkerInfo = _useState2[1];
  var getMarkerById = (0, _react.useCallback)(function (id) {
    var markerShapes = Object.keys(markerInfo.USERDEFINED); // Get all the marker shapes

    // Search for the ID in each marker shape
    for (var _i = 0, _markerShapes = markerShapes; _i < _markerShapes.length; _i++) {
      var shape = _markerShapes[_i];
      var marker = markerInfo.USERDEFINED[shape][id];
      if (marker) {
        return {
          shape: shape,
          marker: marker
        };
      }
    }
    return null; // Return null if ID is not found
  }, [markerInfo]);
  var getNextMarkerIndex = (0, _react.useCallback)(function (type) {
    var _Object$keys;
    var USERDEFINED = markerInfo.USERDEFINED;
    var markerType = _enums.MarkerShape[type];
    var keys = (_Object$keys = Object.keys(USERDEFINED === null || USERDEFINED === void 0 ? void 0 : USERDEFINED[markerType])) !== null && _Object$keys !== void 0 ? _Object$keys : [];
    var count = Math.max(0, keys.length);
    var prefix = _enums.MarkerPrefix[type];
    return "".concat(prefix).concat(count);
  }, [markerInfo]);
  var modifyMarkerInfo = (0, _react.useCallback)(function (_ref) {
    var id = _ref.id,
      type = _ref.type,
      marker = _ref.marker;
    // get marker shape from shape enum
    var markerType = _enums.MarkerShape[type];

    // update USERDEFINED MARKERS
    var modifiedMarkerInfo = _objectSpread(_objectSpread({}, markerInfo), {}, {
      USERDEFINED: _objectSpread(_objectSpread({}, markerInfo.USERDEFINED), {}, _defineProperty({}, markerType, _objectSpread(_objectSpread({}, markerInfo.USERDEFINED[markerType]), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, markerInfo.USERDEFINED[markerType][id]), marker)))))
    });
    return modifiedMarkerInfo;
  }, [markerInfo]);
  var deleteFromMarkerInfo = (0, _react.useCallback)(function (id) {
    var _getMarkerById = getMarkerById(id),
      _getMarkerById$shape = _getMarkerById.shape,
      shape = _getMarkerById$shape === void 0 ? "" : _getMarkerById$shape;
    if (shape === "") {
      // invalid id (marker not found)
      console.warn("Marker shape not found");
      return markerInfo;
    }
    var modifiedMarkerInfo = _objectSpread({}, markerInfo);
    if (modifiedMarkerInfo.USERDEFINED[shape]) {
      delete modifiedMarkerInfo.USERDEFINED[shape][id];
    } else {
      // Handle the case when USERDEFINED[shape] is not defined
      console.warn("Invalid marker shape. What did you do?");
    }
    return modifiedMarkerInfo;
  }, [getMarkerById, markerInfo]);
  var markersAsArray = (_useMemo = (0, _react.useMemo)(function () {
    return (0, _utilities.flatMarkerArray)(markerInfo !== null && markerInfo !== void 0 ? markerInfo : {});
  }, [markerInfo])) !== null && _useMemo !== void 0 ? _useMemo : [];
  return {
    markerInfo: markerInfo,
    markersAsArray: markersAsArray,
    setMarkerInfo: setMarkerInfo,
    modifyMarkerInfo: modifyMarkerInfo,
    deleteFromMarkerInfo: deleteFromMarkerInfo,
    getNextMarkerIndex: getNextMarkerIndex,
    getMarkerById: getMarkerById
  };
}